<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="$attrs"
        v-on="on"
        icon
        :color="btnColor"
        @click="callMethod"
      >
        <img
          v-if="btnImg"
          :src="TremolVIcon"
          :width="btnWidth"
          style="background-color: rgba(255, 255, 255, 0.7); border-radius: 25px;"
        />
        <v-icon v-else :color="btnColor" dark v-bind="attrs" v-on="on">
          {{ btnIcon }}
        </v-icon>
      </v-btn>
    </template>

    <span>{{ btnText }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    btnColor: {
      default: null,
      type: String,
    },
    btnText: {
      type: String,
      default: "",
    },
    btnIcon: {
      type: String,
      default: "mdi-progress-question",
    },
    btnImg: {
      type: String,
      default: null,
    },
    btnWidth: {
      type: Number,
      default: 32,
    },
  },
  methods: {
    callMethod() {
      this.$emit("click");
    },
  },
};
</script>

<style scoped></style>
